const _excluded = ["validateInBottomSheet"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { forwardRef, useState } from 'react';
import { BottomSheetContentLayout } from "../BottomSheet";
import { useOverlayContext } from "../OverlayContext";
import { Typography } from "../Typography";
import { BaseTextField } from "./BaseTextField/BaseTextField";
import { MobileTextFieldTID } from "./BaseTextField/BaseTextField.utils";
import { MobileSummaryCard } from "./MobileSummaryCard";
import styles from "./MobileTextField.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const TextFieldInBottomSheet = /*#__PURE__*/forwardRef(function TextFieldInBottomSheet(props, ref) {
  const {
      validateInBottomSheet
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    hideBottomSheet
  } = useOverlayContext();
  const [tempValue, setTempValue] = useState(props.value);
  const validationResult = validateInBottomSheet === null || validateInBottomSheet === void 0 ? void 0 : validateInBottomSheet(tempValue);
  const error = validationResult ? validationResult.error : props.error;
  const helperText = validationResult ? validationResult.helperText : props.helperText;
  function handleSave() {
    if (tempValue !== props.value && props.onChange) {
      props.onChange({
        target: {
          value: tempValue
        }
      });
    }
    hideBottomSheet();
  }
  return /*#__PURE__*/_jsx(BottomSheetContentLayout, {
    contentClassName: styles.bottomSheetContent,
    footer: {
      primaryAction: {
        text: 'Save',
        onClick: () => handleSave()
      }
    },
    children: /*#__PURE__*/_jsx(BaseTextField, _objectSpread(_objectSpread({}, rest), {}, {
      value: tempValue,
      error: error,
      helperText: helperText,
      onChange: e => setTempValue(e.target.value),
      onKeyDown: () => {},
      ref: ref
    }))
  });
});
export const MobileTextField = /*#__PURE__*/forwardRef(function MobileTextField(props, ref) {
  const {
    testId,
    error,
    label,
    value,
    helperText,
    disabled
  } = props;
  const {
    pushBottomSheetPage
  } = useOverlayContext();
  return /*#__PURE__*/_jsx(MobileSummaryCard, {
    disabled: disabled,
    testId: testId,
    title: label,
    body: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Typography, {
        ellipsis: true,
        testId: MobileTextFieldTID.Value(testId),
        skin: error ? 'error' : 'standard',
        children: value
      }), helperText && /*#__PURE__*/_jsx(Typography, {
        testId: MobileTextFieldTID.HelperText(testId),
        skin: error ? 'error' : 'secondary',
        children: helperText
      })]
    }),
    titleTestId: MobileTextFieldTID.Label(testId),
    editButtonTestId: MobileTextFieldTID.EditButton(testId),
    onEdit: () => {
      pushBottomSheetPage({
        content: /*#__PURE__*/_jsx(TextFieldInBottomSheet, _objectSpread(_objectSpread({}, props), {}, {
          ref: ref
        }))
      });
    }
  });
});